// Copied verbatim from original/src/components/SettingsCard.tsx (ADR-08 §2.1). One addition: the optional
// `testId` is set on the card's own element — the card must stay a direct child of the settings grid
// (App.tsx:41558-41594) so it stretches to the row height like the old one; a wrapper element would not.
import React from 'react';

interface SettingsCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  key?: string;
  testId?: string;
}

export function SettingsCard({ icon, title, children, testId }: SettingsCardProps) {
  return (
    <div data-testid={testId} className="bg-white dark:bg-[#0d1117] rounded-[2.5rem] border border-gray-100 dark:border-[#30363d] overflow-hidden shadow-sm hover:shadow-md transition-all duration-500 group">
      <div className="p-8 border-b border-gray-50 dark:border-[#30363d] bg-gray-50/30 dark:bg-white/5 flex items-center gap-4">
        <div className="p-3 bg-blue-500/10 rounded-2xl group-hover:scale-110 transition-transform duration-500">
          {icon}
        </div>
        <h3 className="text-xl font-black text-gray-900 dark:text-white tracking-tight uppercase">{title}</h3>
      </div>
      <div className="p-8 space-y-6">
        {children}
      </div>
    </div>
  );
}
